import { useQuery } from '@tanstack/react-query'
import { fetchMeetingTypes } from '../services/care_plan';

const GetMeetingTypes = () => {
 const getMeetingTypes = useQuery({
    queryKey:['meetingTypes'],
    queryFn: fetchMeetingTypes
 })
 return getMeetingTypes;
}

export default GetMeetingTypes
